<template>
  <div class="panel">
    <el-row>
      <h1>Features</h1>
    </el-row>
    <el-row class="feature-board">
      <el-col :span="6">
        <div class="title"><i class="el-icon-edit">&nbsp;</i>Middleware</div>
        <div class="content line">A incoming HTTP request can </div>
        <div class="content line">be handled by a chain of </div>
        <div class="content line">middlewares and the final action. </div>
      </el-col>
      <el-col :span="6">
        <div class="title"><i class="el-icon-bell">&nbsp;</i>Json validation</div>
        <div class="content line">Tigo can parse and validate </div>
        <div class="content line">the JSON of a request, checking </div>
        <div class="content line">for example the existence of </div>
        <div class="content line">required values.</div>
      </el-col>
      <el-col :span="6">
        <div class="title"><i class="el-icon-share">&nbsp;</i>Routers</div>
        <div class="content line">Tigo provides two kinds of </div>
        <div class="content line">url route type, organize your</div>
        <div class="content line"> routes better.</div>
      </el-col>
    </el-row>
    <el-row class="feature-board">
      <el-col :span="6">
        <div class="title"><i class="el-icon-document">&nbsp;</i>Template</div>
        <div class="content line">Tigo provides a easy to use API for</div>
        <div class="content line"> XML and HTML rendering.</div>
      </el-col>
      <el-col :span="6">
        <div class="title"><i class="el-icon-menu">&nbsp;</i>API</div>
        <div class="content line">Tigo provides lots of API to</div>
        <div class="content line">build a web service. Include</div>
        <div class="content line">http request API etc.</div>
      </el-col>
      <el-col :span="6">
        <div class="title"><i class="el-icon-edit-outline">&nbsp;</i>Extendable</div>
        <div class="content line">Developers can create new extendable</div>
        <div class="content line">tools, just checkout the sample codes.</div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: "DocumentationFeatures",
    methods: {
      showInfo() {
        this.$alert('你果然点了，并且成功的找到了这里！', '缘分啊！', {
          confirmButtonText: '确定',
          callback: action => {
            this.$message({
              type: 'info',
              message: `action: ${ action }`
            });
          }
        });
      }
    }
  }
</script>

<style scoped>
  .panel {
    width: 100%;
    height: 450px;
    background-color: #f0f0f1;
  }

  h1 {
    margin-top: 39px;
  }

  .title {
    font-size: 20px;
    font-family: "Avenir", serif;
    margin-bottom: 10px;
  }

  .content {
    font-family: "Avenir", serif;
    color: #797e8e;
  }

  .feature-board {
    padding-left: 20%;
    margin-bottom: 30px;
  }

  @media screen and (max-width: 1060px) {
    .panel {
      width: 100%;
      height: 600px;
      background-color: #f0f0f1;
    }
  }

  @media screen and (max-width: 720px) {
    .panel {
      width: 100%;
      height: 700px;
      background-color: #f0f0f1;
    }
  }

  @media screen and (max-width: 500px) {
    .line {display: none}
    .panel {
      width: 100%;
      height: 300px;
      background-color: #f0f0f1;
    }
  }

  .line {}
</style>



// WEBPACK FOOTER //
// src/components/en/DocumentationFeatures.vue